import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, computed } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import AccountInformationTab from "@/modules/Clients/Settings/AccountInformationTab.vue"
import ClientAdmins from "@/modules/Clients/Settings/ClientAdmins.vue"
import CompanyInformationTab from "@/modules/Clients/Settings/CompanyInformationTab.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import { ClientDetailFragmentFragment } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const { client } = useAccountContext()

const clientFragment = computed<ClientDetailFragmentFragment>(
  () => client as ClientDetailFragmentFragment
)

const selectedTaskTab = ref<number | null>(null)

const searchParams = new URLSearchParams(window.location.search)
const url = new URL(window.location.href)

const tabsMappings: Record<number, string> = {
  0: "account",
  1: "members",
  2: "company",
}

const onTabChange = (tab: number) => {
  searchParams.set("tab", tabsMappings[tab])
  url.search = searchParams.toString()
  window.history.replaceState({}, "", url.toString())
}

onBeforeMount(() => {
  const currentTab = searchParams.get("tab")
  if (currentTab !== null) {
    const tabValue = Object.values(tabsMappings).indexOf(currentTab)
    if (tabValue !== -1) {
      selectedTaskTab.value = tabValue
    }
  }
})

return { __sfc: true,client, clientFragment, selectedTaskTab, searchParams, url, tabsMappings, onTabChange, AppPage, AccountInformationTab, ClientAdmins, CompanyInformationTab }
}

})